import { Loading } from 'element-ui';

let loadingCount = 0;
let loading;

const startLoading = () => {
  loading = Loading.service({
    lock: true,
    text: '保存中......',
    background: 'rgba(0, 0, 0, 0.7)'
  });
};

const endLoading = () => {
  loading && loading.close()
  // loading.close();
};

export const showLoading = () => {
  // if (loadingCount === 0) {
  //   startLoading();
  // }
  // loadingCount += 1;
  loadingCount += 1
  startLoading()
};

export const hideLoading = () => {
  // if (loadingCount <= 0) {
  //   return;
  // }
  // loadingCount -= 1;
  // console.log(loadingCount)
  // if (loadingCount === 0) {
  //   endLoading();
  // }
  setTimeout(() => {
    endLoading()
  }, 300);
};
